module.exports = __webpack_public_path__ + "img/Go-Forward.be35b938.svg";